import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';

const refundMutation = gql`mutation create_refund($refund: PaymentInput!){
  createRefund(refund: $refund){
    id
  }
}`;

@Injectable({
  providedIn: 'root'
})
export class RefundOrderService {

  constructor(private apollo: Apollo) { }

  refundOrder(refund:any){
    return this.apollo.use('external').mutate({
      mutation: refundMutation,
      variables: {
        refund
      }
    }).toPromise();
  }
}
